module.exports = __webpack_public_path__ + "img/img-logo.f3769bb3.svg";